import { uuid } from './helpers';
import type { Student } from '../types';

export function parseNames(input: string): string[] {
  const raw = input
    .replace(/[,;\t]+/g, '\n')
    .split('\n')
    .map((s) => s.trim())
    .filter(Boolean);

  const names: string[] = [];
  for (const token of raw) {
    const match = token.match(/^(.+?)\s*\*\s*(\d+)$/);
    if (match) {
      const name = match[1].trim();
      const count = parseInt(match[2], 10);
      for (let i = 0; i < count; i++) names.push(name);
    } else {
      names.push(token);
    }
  }
  return names;
}

export function namesToStudents(names: string[]): Student[] {
  const seen = new Map<string, number>();
  return names.map((rawName) => {
    const count = (seen.get(rawName) ?? 0) + 1;
    seen.set(rawName, count);
    const name = count > 1 ? `${rawName} (${count})` : rawName;
    return {
      id: uuid(),
      name,
      weight: 1,
      pickCount: 0,
      excluded: false,
    };
  });
}

export function parseAndCreateStudents(input: string): Student[] {
  return namesToStudents(parseNames(input));
}
